module.exports = __webpack_public_path__ + "img/p3-wrapper.add6f794.png";